export default {
  title: 'Nebula buds AI Call', // "Nebula buds AI通话" 翻译为英语
  userID: 'User ID : ', // "用户ID : "
  hurryUp: 'Waiting for the other party to call', // "等待对方呼叫"
  waitingCall: 'Waiting for the other party to call on this page, please do not close the page prematurely.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Subtitle Switch', // "字幕开关"
  initWait: 'Waiting for initialization', // "等待初始化"
  initSuccess: 'Initialization complete, waiting for the other party to call. Please do not close the page!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Call connected', // "电话接通"
  callEnd: 'Call ended', // "通话结束"
  careful: 'Notice : ', // "注意 : "
  wait: 'Call component is ready, waiting for the other party to call', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabic', // "阿拉伯语"
    da: 'Danish', // "丹麦语"
    de: 'German', // "德语"
    en: 'English', // "英语"
    es: 'Spanish', // "西班牙语"
    fil: 'Filipino', // "菲律宾语"
    fr: 'French', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesian', // "印度尼西亚语"
    it: 'Italian', // "意大利语"
    ja: 'Japanese', // "日文"
    ko: 'Korean', // "韩语"
    ms: 'Malay', // "马来语"
    no: 'Norwegian', // "挪威语"
    pt: 'Portuguese', // "葡萄牙语"
    ru: 'Russian', // "俄语"
    sv: 'Swedish', // "瑞典语"
    th: 'Thai', // "泰语"
    tr: 'Turkish', // "土耳其语"
    vi: 'Vietnamese', // "越南语"
    zh: 'Chinese' // "中文"
  }
}
